import React, {useState} from 'react';
import {ColorContainer, ColorTitle} from "./settings-menu.styles";
import {useTranslation} from "react-i18next";
import { useThemeDetector } from "../../hook/theme-detector";
import { ACCENT_COLORS, THEMES} from "../../constants/theme";

const SettingsMenu = () => {

    const [t] = useTranslation();
    const isDark = useThemeDetector();
    const [theme, setTheme] = useState(localStorage.getItem(THEMES.KEY) ? localStorage.getItem(THEMES.KEY) : THEMES.LIGHT);
    const [accentColor, setAccentColor] = useState(localStorage.getItem(ACCENT_COLORS.KEY) ? localStorage.getItem(ACCENT_COLORS.KEY) : ACCENT_COLORS.BLUE);

    const changeTheme = (theme) => {
        switch (theme) {
            case THEMES.DARK: {
                document.body.classList.add('dark-mode');
                break;
            }
            case THEMES.LIGHT: {
                document.body.classList.remove('dark-mode');
                break;
            }
            default: {
                if(isDark) {
                    document.body.classList.add('dark-mode')
                } else {
                    document.body.classList.remove('dark-mode');
                }
            }
        }

        setTheme(theme);
        localStorage.setItem(THEMES.KEY, theme);
    };

    const changeAccentColor = (color, colorCode) => {
        document.documentElement.style.setProperty('--accent-color', colorCode);
        setAccentColor(color);
        localStorage.setItem(ACCENT_COLORS.KEY, color);
    }

    return (
        <div className='lng-dir'>
            <p>{t('choose theme')}</p>
            <div className='d-flex flex-wrap'>
                <button className='simple-btn mx-2' onClick={() => changeTheme(THEMES.LIGHT)}>
                    <ColorContainer color='#FFF' className={theme === THEMES.LIGHT ? 'active' : ''} />
                    <ColorTitle>{t('light')}</ColorTitle>
                </button>
                <button className='simple-btn mx-2' onClick={() => changeTheme(THEMES.DARK)}>
                    <ColorContainer color='rgb(55, 54, 55)' className={theme === THEMES.DARK ? 'active' : ''} />
                    <ColorTitle>{t('dark')}</ColorTitle>
                </button>
                <button className='simple-btn mx-2' onClick={() => changeTheme(THEMES.AUTO)}>
                    <ColorContainer color={isDark ? 'rgb(55, 54, 55)' : '#FFF'} className={theme === THEMES.AUTO ? 'active' : ''} />
                    <ColorTitle>{t('auto')}</ColorTitle>
                </button>
            </div>
            <p className='mt-4'>{t('accent theme')}</p>
            <div className='d-flex flex-wrap'>
                <button className='simple-btn mx-2'
                        onClick={() => changeAccentColor(ACCENT_COLORS.BLUE, 'var(--blue-color)')}>

                    <ColorContainer color='var(--blue-color)' className={accentColor === ACCENT_COLORS.BLUE ? 'active' : ''} />
                    <ColorTitle>{t('blue')}</ColorTitle>
                </button>
                <button className='simple-btn mx-2'
                        onClick={() => changeAccentColor(ACCENT_COLORS.PURPLE, 'var(--purple-color)')}>

                    <ColorContainer color='var(--purple-color)' className={accentColor === ACCENT_COLORS.PURPLE ? 'active' : ''} />
                    <ColorTitle>{t('purple')}</ColorTitle>
                </button>
                <button className='simple-btn mx-2'
                        onClick={() => changeAccentColor(ACCENT_COLORS.PINK, 'var(--pink-color)')}>

                    <ColorContainer color='var(--pink-color)' className={accentColor === ACCENT_COLORS.PINK ? 'active' : ''} />
                    <ColorTitle>{t('pink')}</ColorTitle>
                </button>
                <button className='simple-btn mx-2'
                        onClick={() => changeAccentColor(ACCENT_COLORS.RED, 'var(--red-color)')}>

                    <ColorContainer color='var(--red-color)' className={accentColor === ACCENT_COLORS.RED ? 'active' : ''} />
                    <ColorTitle>{t('red')}</ColorTitle>
                </button>
                <button className='simple-btn mx-2'
                        onClick={() => changeAccentColor(ACCENT_COLORS.ORANGE, 'var(--orange-color)')}>

                    <ColorContainer color='var(--orange-color)' className={accentColor === ACCENT_COLORS.ORANGE ? 'active' : ''} />
                    <ColorTitle>{t('orange')}</ColorTitle>
                </button>
                <button className='simple-btn mx-2'
                        onClick={() => changeAccentColor(ACCENT_COLORS.YELLOW, 'var(--yellow-color)')}>

                    <ColorContainer color='var(--yellow-color)' className={accentColor === ACCENT_COLORS.YELLOW ? 'active' : ''} />
                    <ColorTitle>{t('yellow')}</ColorTitle>
                </button>
                <button className='simple-btn mx-2'
                        onClick={() => changeAccentColor(ACCENT_COLORS.GREEN, 'var(--green-color)')}>
                    <ColorContainer color='var(--green-color)' className={accentColor === ACCENT_COLORS.GREEN ? 'active' : ''} />
                    <ColorTitle>{t('green')}</ColorTitle>
                </button>
            </div>
        </div>
    );
};

export default SettingsMenu;
